import i18n from 'i18next';

export const MENU_FILTER_FIELDS = [
	{
		name: 'name',
		label: i18n.t('filters:fields.name'),
		type: 'text',
		required: false,
		labelColumn: 3,
		inputColumn: 9
	},
	{
		name: 'link',
		label: i18n.t('filters:fields.link'),
		type: 'text',
		required: false,
		labelColumn: 3,
		inputColumn: 9
	},
	{
		name: 'platform_group',
		label: i18n.t('filters:fields.platform'),
		type: 'select',
		required: false,
		labelColumn: 3,
		inputColumn: 9
	}
];
